import { makeVar } from '@apollo/client'

export type DealLoadStatus = {
  dealStatus: string
  didError: boolean
  errorMessage: string
  isCurrentVersionDeal: boolean
  versionStatus: string
}

export const dealLoadStatusVar = makeVar<DealLoadStatus | null>(null)

export const getDealLoadStatus = (): DealLoadStatus | null => dealLoadStatusVar()

export const setDealLoadStatus = (value: DealLoadStatus | null): void => {
  dealLoadStatusVar(value)
}

export const resetDealLoadStatus = (): void => {
  dealLoadStatusVar(null)
}
